import { render, staticRenderFns } from "./ProductDetailsPage.vue?vue&type=template&id=079b5eae&scoped=true&"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsPage.vue?vue&type=style&index=0&id=079b5eae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b5eae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadCrumbs: require('/var/www/ep-web/components/BreadCrumbs.vue').default,SlideShow: require('/var/www/ep-web/components/SlideShow.vue').default,AttributesCheckbox: require('/var/www/ep-web/components/AttributesCheckbox.vue').default,ModalProducts: require('/var/www/ep-web/components/ModalProducts.vue').default})
